import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AcessoexternoProvider } from '../../providers/acessoexterno/acessoexterno';
import { DadosProvider } from '../../providers/dados/dados';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ViewProvider } from '../../providers/view/view';

@Component({
  selector: 'page-endereco',
  templateUrl: 'endereco.html',
})
export class EnderecoPage {

  endereco:any = {rua:"", numero:"", bairro_id : 0, complemento:"", cidadeexterna:"", bairroexterno:""};

  cidadeSelecionada;

  cidades:Array<any> = [];
  bairros:Array<any> = [];

  constructor(public navCtrl: NavController, navParams:NavParams, private acessoE:AcessoexternoProvider, private dadosP:DadosProvider, private server:SemovelProvider,
    private view:ViewProvider) {
  
    if(navParams.get('endereco')){
      this.endereco = navParams.get('endereco');
    }
  }

  ionViewDidLoad() {
    this.buscarCidade();
  }
  
  buscarCidade(){
    this.server.postData({method:"cidade/list"})
    .subscribe(
      (response) => {
        this.cidades = response;
        if(this.cidades && this.cidades.length){
          this.cidadeSelecionada = this.cidades[0];
        }
        this.buscarBairros();
      },
      (err) =>{
        console.error(err);
      }

    )
  }

  buscarBairros(){
    if(!this.cidadeSelecionada){
      return;
    }
    this.server.postData({method : "bairro/list"}, {cidadeId:this.cidadeSelecionada.id})
    .subscribe(
      (bairros) => this.bairros = bairros ,
      (erro) =>  console.error(erro)
    )
  }
  entrarEmContato(){
    this.acessoE.entrarEmContato();
  }
  
  validar(){
    if(!this.endereco.rua || this.endereco.rua.length == 0  ){
      this.view.showMessage("É necessário informar a rua.");
      return false; 
    }

    if(!this.endereco.numero || this.endereco.numero.length == 0  ){
      this.view.showMessage("É necessário informar o número.");
      return false; 
    }

    if(!this.endereco.bairro || !this.endereco.bairro.id  ){
      this.view.showMessage("É necessário informar o bairro.");
      return false; 
    }
    
    return true;
  }
  
  confirmar(){
    if(!this.validar()){
      return;
    }
    
    this.server.postData({method:"cliente/salvarEndereco"}, this.endereco).subscribe(
      (dados) => {
        this.dadosP.salvarEndereco(dados.endereco);
        this.view.showMessage("Endereço salvo com sucesso.");
        this.navCtrl.pop();
      },
      (erro) => {
        console.log("Erro ao salvar o endereço no servidor.");
        this.view.showMessage("Não foi possível salvar seu endereço.<br>"+erro);
      }
    );
  }

  cidadeChanged($event){
    console.log($event);
    this.cidadeSelecionada = $event;
    this.buscarBairros();
  }

  move_focus(componente){
    componente.setFocus();
  }

  alterarCidade(){
    this.buscarBairros();
  }

  compareBairro(e1, e2): boolean {
    return e1 && e2 ? e1.id === e2.id : e1 === e2;
  }

  changeCEP(event){
    // console.log(event);
    this.endereco.cep = event;

    if(event.length == 8){
      this.buscarCEP();
    }
  }

  buscarCEP(){
    this.server.postData({method : "cep"}, {cep:this.endereco.cep})
    .subscribe(
      (endereco) => {
        console.log(endereco)
        this.preencherEndereco(endereco);
      },
      (erro) =>  console.error(erro)
    )
  }

  preencherEndereco(endereco){
    this.endereco.rua = endereco.logradouro;

    const cidade = this.cidades.find(cidade => {
      return cidade.nome.toLowerCase() == endereco.localidade.toLowerCase();
    });

    const bairro = this.bairros.find(bairro => {
      return bairro.nome.toLowerCase() == endereco.bairro.toLowerCase();
    });

    if(bairro){
      this.endereco.bairro = bairro;
      this.endereco.bairro_id = bairro.id;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/endereco/endereco.ts